import React, { useRef } from 'react';

import { Slide } from './dishMediaContent.types';
import s from './dish-media-content.module.scss';


type SliderHoverControlsProps = {
    slides: Slide[],
    handleHoverSlideArea: (slideIndex: number) => void, // eslint-disable-line no-unused-vars
    onClickOpenDetails?: (slide?: Slide) => void, // eslint-disable-line no-unused-vars
};

const noop = () => {};


export function SliderHoverControls({
    slides,
    handleHoverSlideArea,
    onClickOpenDetails = noop,
}: SliderHoverControlsProps) {
    const isHoveringRef = useRef(false);

    return (
        <div className={s.sliderHoverControls}>
            <button
                type="button"
                className={s.sliderHoverControl}
                onMouseEnter={() => {
                    isHoveringRef.current = true;
                    handleHoverSlideArea(0);
                }}
                onClick={() => onClickOpenDetails()}
            >
                slide 1
            </button>
            {slides.map((slide, index) => {
                const key = slide.src || slide.imageUrl;

                return (
                    <button
                        key={key}
                        type="button"
                        className={s.sliderHoverControl}
                        onMouseEnter={() => {
                            isHoveringRef.current = true;
                            handleHoverSlideArea(index + 1);
                        }}
                        onMouseLeave={() => {
                            isHoveringRef.current = false;
                            setTimeout(() => {
                                if (!isHoveringRef.current) {
                                    handleHoverSlideArea(0);
                                }
                            }, 100);
                        }}
                        onClick={() => onClickOpenDetails(slide)}
                    >
                        slide
                        {' '}
                        {index + 2}
                    </button>
                );
            })}
        </div>
    );
}
